import { render, staticRenderFns } from "./ClientGlobalTab.vue?vue&type=template&id=533d704c"
import script from "./ClientGlobalTab.vue?vue&type=script&lang=js"
export * from "./ClientGlobalTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports